import { Component, inject, OnInit, Input, ChangeDetectorRef, OnChanges, SimpleChanges, ViewChild, TemplateRef } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap/modal';
import { FormsModule } from '@angular/forms';
import { AddressEdit } from "../Controlls/AddressEdit"
import { DateSelect } from "../Controlls/DateSelect"
import { Notfallplan } from '../../Api/DcoApi/Notfallplan';
import { RestClient } from '../../Api/DcoApi/Client/RestClient';
import { ToastService } from '../Services/Toasts/ToastService';
import { CommonModule } from '@angular/common';
import { IsSpezialUserDirective, IsWelcomeCallDirective } from '../../Admin/AdminGuard';
import {Phonenumber} from '../../Directives/Phonenumber';

@Component({
  imports: [
    FormsModule, AddressEdit, DateSelect, CommonModule, IsWelcomeCallDirective, IsSpezialUserDirective,Phonenumber
  ],
  selector: 'Notfallplan',
  templateUrl: './Notfallplan.html',
  standalone: true,
  styleUrl: './Notfallplan.css'
})
export class NP implements OnChanges {
  toastService: ToastService;
  constructor(private cdr: ChangeDetectorRef) {
    this.toastService = inject(ToastService);
  }
    ngOnChanges(changes: SimpleChanges): void {
      this.LoadPlan();
    }
   ngOnInit(): void {
     this.LoadPlan();
  }
  modal = inject(NgbActiveModal);
  Plan: Notfallplan | null = null;
  Client: RestClient = new RestClient();
  pflegegradInfoEnum = [
    { id: 0, name: 'Ja, mit Kostenübernahme' },
    { id: 1, name: 'Ja, ohne Kostenübernahme' },
    { id: 2, name: 'Unbekannt' },
    { id: 3, name: 'Kein Pflegegrad' }
  ];

  async LoadPlan() {
    this.Plan = await this.Client.Get<Notfallplan>(`/Backend/Api/V2/Akte/${this.VersichertenNR}/Patient/Notfallplan`) ?? {} as Notfallplan;
    this.cdr.detectChanges();
  }

  async SavePlan() {
    if (this.Plan != null)
      this.Plan = await this.Client.Post<Notfallplan, Notfallplan>(`/Backend/Api/V2/Akte/${this.VersichertenNR}/Patient/Notfallplan`, this.Plan);
    this.cdr.detectChanges();
    this.toastService.show({ template: this.successTpl, classname: 'bg-success text-light show', delay: 10000 })
  }

  @Input() VersichertenNR: string | null = null;
  @ViewChild('successTpl') public successTpl!: TemplateRef<any>;
}
